import { render, staticRenderFns } from "./BrowseBuilding1men.vue?vue&type=template&id=0247b781&scoped=true&"
import script from "./BrowseBuilding1men.vue?vue&type=script&lang=js&"
export * from "./BrowseBuilding1men.vue?vue&type=script&lang=js&"
import style0 from "./BrowseBuilding1men.vue?vue&type=style&index=0&id=0247b781&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0247b781",
  null
  
)

export default component.exports